import { useEffect, useRef, useState } from 'react';
import { vorschauHtml } from './vorschauHtml';
import './MailVorschau.css';

/** Breite, in der die Mail gesetzt und dann verkleinert wird (620 + Rand). */
const BREITE = 660;

/**
 * Verkleinerte Ansicht einer Mail für Galerien: nur zum Anschauen, ohne
 * Skripte und ohne Klicks im Rahmen. Füllt die Fläche des Elternelements.
 */
export function MailMiniatur({ html }: { html: string }) {
  const box = useRef<HTMLDivElement>(null);
  const [faktor, setFaktor] = useState(0.4);

  useEffect(() => {
    const el = box.current;
    if (!el) return;
    const messen = () => { if (el.clientWidth > 0) setFaktor(el.clientWidth / BREITE); };
    messen();
    const ro = new ResizeObserver(messen);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div ref={box} className="mv-miniatur" aria-hidden="true">
      <iframe
        title="Verkleinerte Vorschau"
        tabIndex={-1}
        sandbox=""
        loading="lazy"
        srcDoc={vorschauHtml(html)}
        style={{ width: BREITE, height: `${100 / faktor}%`, transform: `scale(${faktor})` }}
      />
    </div>
  );
}
